import { html } from 'lit';
import { Paperclip } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-paperclip')
export class PdsIconPaperclip extends PdsIcon {
  @state()
  icon = Paperclip;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
